import { TableField } from "../../table-field";
const descricao: TableField = {
    key: "descricao",
    label: "Descrição",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

const status: TableField = {
    key: "status",
    label: "Status",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

const arquivo = {
    key: "arquivo",
    label: "Arquivo",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

const actions = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const fieldsHomologacao: TableField[] = [
    descricao,
    status,
    arquivo,
    actions,

];
